export { baseButtonPropDefs as buttonPropDefs } from './base-button.props.js';
